import { Input, Select, Spin } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit, FiTrash, FiUserCheck, FiUserX } from "react-icons/fi";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { DataTable } from "@/components";
import { userRole, userRoleFormate } from "@/constant";
import { flare } from "@flareapp/js";

export default function DeviceListOnSiteLocation({ siteLocationId }) {
  const [total, setTotal] = useState();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  // const [searchBySatus, setSearchBySatus] = useState("active");
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [role, setUserRole] = useState("");

  const getUsers = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/user`, {
        withCredentials: true,
        params: {
          limit,
          page,
          site: siteLocationId,
          // status: searchBySatus,
          searchText: searchTerm,
          role,
        },
      });
      setTotal(response.data.count);
      setUsers(response.data.results);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };

  // useEffect(() => {
  //   getUsers();
  // }, []);

  const columns = [
    {
      title: "No.",
      key: "no",
      render: (_, __, index) => index + 1 + limit * (page - 1),
      width: "60px",
    },
    {
      title: "User Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "User Type",
      dataIndex: "role",
      key: "user_type",
      render: (role) => (
        <div className="text-capitalize">
          {role === userRole.businessAdmin
            ? "Business Admin"
            : role === "user"
              ? "Site User"
              : role === userRole.admin
                ? "Site admin"
                : role}
        </div>
      ),
    },
    {
      title: "Date Created",
      key: "Date_Created",
      dataIndex: "createdAt",
      render: (createdAt) => moment(createdAt).format("DD/MM/YYYY"),
      // width: "130px",
    },
    {
      title: "Status",
      key: "isActive",
      dataIndex: "isActive",
      render: (isActive) => (
        <div>
          {isActive ? (
            <span className="badge text-bg-success">Active</span>
          ) : (
            <span className="badge text-bg-danger">Deactivated</span>
          )}
        </div>
      ),
    },
    {
      title: "Action",
      key: "Action",
      align: "center",
      width: "220px",
      render: (_, row) => (
        <div>
          <Link to={`/users/details/` + row._id + `?role=${row.role}`} className="btn btn-az-primary me-1">
            <AiOutlineEye title="View Profile" />
          </Link>
          <Link to={`/users/edit/` + row._id + `?role=${row.role}`} className="btn btn-edit me-1">
            <FiEdit title="Edit Profile" />
          </Link>
          {(() => {
            switch (row.isActive) {
              case true:
                return (
                  <button
                    className="btn btn-warning me-1"
                    onClick={() => activeDeactiveUser(row._id, row.isActive, row.role)}
                  >
                    <FiUserX title="Inactive Account" />
                  </button>
                );
              case false:
                return (
                  <button
                    className="btn btn-secondary  me-1"
                    onClick={() => activeDeactiveUser(row._id, row.isActive, row.role)}
                  >
                    <FiUserCheck title="Active Account" />
                  </button>
                );
              default:
                return;
            }
          })()}
          <button className="btn btn-danger" onClick={() => deleteUser(row._id)}>
            <FiTrash title="Delete User" />
          </button>
        </div>
      ),
    },
  ];
  const activeDeactiveUser = async (userId, isActive, role) => {
    const data = {
      isActive: !isActive,
    };
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to ${!isActive ? "activate" : "deactivate"} this ${
        role === userRole.user ? "customer" : role
      }?`,
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.put(`/user/` + userId, data, { withCredentials: true }).then(() => {
          getUsers();
          Swal.fire({
            title: "Done!",
            text: "User Status Successfully Changed.",
            icon: "success",
            timer: 2000,
            button: false,
          });
        });
      }
    });
  };

  const deleteUser = async (userId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this user?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`/user/` + userId, { withCredentials: true }).then(() => {
          getUsers();
          Swal.fire({
            title: "Done!",
            text: "User Deleted Successfully",
            icon: "success",
            timer: 2000,
            button: false,
          });
        });
      }
    });
  };

  const searchHandler = (e) => {
    e.preventDefault();
    getUsers();
  };
  useEffect(() => {
    getUsers();
  }, [searchTerm, limit, page, role]);

  return (
    <Spin spinning={isLoading}>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card card-dashboard-six">
            <div className="card-header pb-2">
              <div className="w-100">
                <label className="az-content-label">User List</label>
                <div className="d-md-flex my-2">
                  <Select
                    name="role"
                    size="large"
                    style={{ maxWidth: "300px", width: "100%" }}
                    value={role || ""}
                    onChange={(role) => {
                      setPage(1);
                      setUserRole(role);
                    }}
                  >
                    <option value={""}>All Users</option>
                    {Object.entries(userRoleFormate).map((item, ind) =>
                      [userRoleFormate.superAdmin].includes(item[1]) ? null : (
                        <option key={ind} value={item[0]}>
                          {item[1]}{" "}
                        </option>
                      ),
                    )}
                  </Select>
                  <div className="ms-auto my-2">
                    <form onSubmit={searchHandler} className="input-group">
                      <Input
                        style={{ maxWidth: "300px", width: "100%" }}
                        size="large"
                        type="search"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => {
                          setPage(1);
                          setSearchTerm(e.target.value);
                        }}
                        // aria-label="search"
                        // className="form-control"
                      />
                      {/* <Button variant="success" type="submit">
                        search
                      </Button> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <DataTable
              dataSource={users}
              columns={columns}
              rowKey={(record) => record.id}
              pagination={{
                defaultPageSize: limit,
                current: page,
                total,
                showSizeChanger: true,
                onShowSizeChange: (_, pageSize) => {
                  setLimit(pageSize);
                },
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                pageSizeOptions: [10, 20, 50],
                responsive: true,
              }}
              onChange={(pagination) => {
                setPage(pagination.current);
              }}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
}

DeviceListOnSiteLocation.propTypes = {
  siteLocationId: PropTypes.string,
};
